import { DoqFaceSvgProps } from '../types';

const CapabilityMapError = ({ size, className }: DoqFaceSvgProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 320 320"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
  >
    <g clipPath="url(#clip0_2662_52380)">
      {/* mask to hide the bottom outline of the circle */}
      <mask id="bottom-mask-capability-map-error">
        <circle cx="160" cy="160" r="160" fill="white" />
        <path d="M 240,300 A 160,160 0 0,1 80,300 L 160,160 Z" fill="black" />
      </mask>
      <circle
        cx="160"
        cy="160"
        r="160"
        fill="#EBD4FF"
        mask="url(#bottom-mask-capability-map-error)"
      />
      <mask
        id="mask0_5402_43618"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="320"
        height="320"
      >
        <circle cx="160" cy="160" r="160" fill="#FCBF4C" />
      </mask>
      <g mask="url(#mask0_5402_43618)">
        <rect x="80" y="120" width="160" height="200" fill="white" />
      </g>
      <path
        d="M142 184C146.418 184 150 180.418 150 176C150 171.582 146.418 168 142 168C137.582 168 134 171.582 134 176C134 180.418 137.582 184 142 184Z"
        fill="#C07E02"
      />
      <path
        d="M178 184C182.418 184 186 180.418 186 176C186 171.582 182.418 168 178 168C173.582 168 170 171.582 170 176C170 180.418 173.582 184 178 184Z"
        fill="#C07E02"
      />
      <g opacity="0.5">
        <path
          d="M89 241C89 236.582 92.5817 233 97 233H118.697C123.115 233 126.697 236.582 126.697 241V295.066C126.697 299.484 123.115 303.066 118.697 303.066H97C92.5817 303.066 89 299.484 89 295.066V241Z"
          fill="#C07E02"
        />
        <path
          d="M193.155 241C193.155 236.582 196.737 233 201.155 233H222.852C227.27 233 230.852 236.582 230.852 241V295.066C230.852 299.484 227.27 303.066 222.852 303.066H201.155C196.737 303.066 193.155 299.484 193.155 295.066V241Z"
          fill="#C07E02"
        />
        <path
          d="M145.007 233C140.588 233 137.007 236.582 137.007 241V295.066C137.007 299.484 140.588 303.066 145.007 303.066H174.845C179.264 303.066 182.845 299.484 182.845 295.066V241C182.845 236.582 179.264 233 174.845 233H145.007Z"
          fill="#C07E02"
        />
      </g>
      <path
        d="M204.704 239.62C202.36 239.62 200.46 241.521 200.46 243.865C200.46 246.209 202.36 248.11 204.704 248.11H219.675C222.02 248.11 223.92 246.209 223.92 243.865C223.92 241.521 222.02 239.62 219.675 239.62H204.704Z"
        fill="white"
      />
      <path
        d="M200.46 259.46C200.46 257.116 202.36 255.215 204.704 255.215H219.675C222.02 255.215 223.92 257.116 223.92 259.46C223.92 261.804 222.02 263.705 219.675 263.705H204.704C202.36 263.705 200.46 261.804 200.46 259.46Z"
        fill="white"
      />
      <path
        d="M204.704 271.054C202.36 271.054 200.46 272.954 200.46 275.298C200.46 277.642 202.36 279.543 204.704 279.543H219.675C222.02 279.543 223.92 277.642 223.92 275.298C223.92 272.954 222.02 271.054 219.675 271.054H204.704Z"
        fill="white"
      />
      <path
        d="M100.549 287.411C98.2051 287.411 96.3047 289.312 96.3047 291.656C96.3047 294 98.2051 295.901 100.549 295.901H115.521C117.865 295.901 119.765 294 119.765 291.656C119.765 289.312 117.865 287.411 115.52 287.411H100.549Z"
        fill="white"
      />
      <path
        d="M204.704 287.411C202.36 287.411 200.46 289.312 200.46 291.656C200.46 294 202.36 295.901 204.704 295.901H219.675C222.02 295.901 223.92 294 223.92 291.656C223.92 289.312 222.02 287.411 219.675 287.411H204.704Z"
        fill="white"
      />
      <path
        d="M145.889 291.656C145.889 289.312 147.789 287.411 150.133 287.411H170.172C172.516 287.411 174.416 289.312 174.416 291.656C174.416 294 172.516 295.901 170.172 295.901H150.133C147.789 295.901 145.889 294 145.889 291.656Z"
        fill="white"
      />
      <path
        d="M96.3047 275.298C96.3047 272.954 98.2051 271.054 100.549 271.054H115.52C117.865 271.054 119.765 272.954 119.765 275.298C119.765 277.642 117.865 279.543 115.521 279.543H100.549C98.2051 279.543 96.3047 277.642 96.3047 275.298Z"
        fill="white"
      />
      <path
        d="M150.133 271.054C147.789 271.054 145.889 272.954 145.889 275.298C145.889 277.642 147.789 279.543 150.133 279.543H170.172C172.516 279.543 174.416 277.642 174.416 275.298C174.416 272.954 172.516 271.054 170.172 271.054H150.133Z"
        fill="white"
      />
      <path
        d="M100.549 255.215C98.2051 255.215 96.3047 257.116 96.3047 259.46C96.3047 261.804 98.2051 263.705 100.549 263.705H115.521C117.865 263.705 119.765 261.804 119.765 259.46C119.765 257.116 117.865 255.215 115.52 255.215H100.549Z"
        fill="white"
      />
      <path
        d="M145.889 259.46C145.889 257.116 147.789 255.215 150.133 255.215H170.172C172.516 255.215 174.416 257.116 174.416 259.46C174.416 261.804 172.516 263.705 170.172 263.705H150.133C147.789 263.705 145.889 261.804 145.889 259.46Z"
        fill="white"
      />
      <path
        d="M96.3047 243.865C96.3047 241.521 98.2051 239.62 100.549 239.62H115.52C117.865 239.62 119.765 241.521 119.765 243.865C119.765 246.209 117.865 248.11 115.521 248.11H100.549C98.2051 248.11 96.3047 246.209 96.3047 243.865Z"
        fill="white"
      />
      <path
        d="M150.133 239.62C147.789 239.62 145.889 241.521 145.889 243.865C145.889 246.209 147.789 248.11 150.133 248.11H170.172C172.516 248.11 174.416 246.209 174.416 243.865C174.416 241.521 172.516 239.62 170.172 239.62H150.133Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M159 200C153.078 200 147.907 203.217 145.141 208L150.056 208C152.253 205.545 155.446 204 159 204C162.554 204 165.747 205.545 167.944 208L172.859 208C170.093 203.217 164.922 200 159 200Z"
        fill="#C07E02"
      />
      <circle cx="160.011" cy="70.0237" r="6.41723" fill="#418B82" />
      <path
        d="M74.4531 140.332C74.4531 100.974 112.836 68.9541 160.016 68.9541C207.196 68.9541 245.579 100.974 245.579 140.332V157.726L207.132 150.353C176.121 144.442 143.911 144.442 112.9 150.353L74.4531 157.726V140.332Z"
        fill="#500052"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M76.8686 167.531L76.8672 167.532C73.8767 168.8 70.4246 167.404 69.1561 164.413C67.8874 161.422 69.2835 157.969 72.2743 156.701L74.5715 162.116C72.2743 156.701 72.2767 156.7 72.2767 156.7L72.3207 156.681L72.4289 156.636C72.5213 156.597 72.6543 156.542 72.8266 156.471C73.171 156.33 73.6724 156.126 74.3204 155.87C75.6162 155.357 77.4992 154.631 79.8859 153.763C84.6567 152.028 91.4535 149.722 99.6052 147.417C115.851 142.823 137.74 138.156 159.802 138.156C181.864 138.156 203.753 142.823 219.999 147.417C228.15 149.722 234.947 152.028 239.718 153.763C242.105 154.631 243.988 155.357 245.283 155.87C245.931 156.126 246.433 156.33 246.777 156.471C246.95 156.542 247.083 156.597 247.175 156.636L247.283 156.681L247.314 156.694L247.327 156.7C247.327 156.7 247.33 156.701 245.032 162.116L247.33 156.701C250.32 157.969 251.716 161.422 250.448 164.413C249.179 167.403 245.727 168.8 242.737 167.532L242.735 167.531L242.72 167.525L242.643 167.493C242.571 167.463 242.46 167.417 242.309 167.355C242.009 167.231 241.553 167.046 240.953 166.809C239.751 166.333 237.972 165.647 235.698 164.82C231.147 163.165 224.626 160.952 216.797 158.738C201.081 154.294 180.355 149.921 159.802 149.921C139.249 149.921 118.522 154.294 102.807 158.738C94.9778 160.952 88.4573 163.165 83.9061 164.82C81.6317 165.647 79.8524 166.333 78.6512 166.809C78.0507 167.046 77.595 167.231 77.2944 167.355C77.1441 167.417 77.0326 167.463 76.9612 167.493L76.8843 167.525L76.8686 167.531Z"
        fill="#6DBCB4"
      />
      <path d="M157.349 95.52H150.117V102.751H157.349V95.52Z" fill="white" />
      <path
        d="M171.815 109.986H150.117V117.217H171.815V109.986Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2662_52380">
        <rect width="320" height="320" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export { CapabilityMapError };
